<template>
	<div class="order-info">
		<!-- 导航 -->
		<van-nav-bar
		  title="订单详情"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/>
		<!-- 详情信息 -->
		<div class="info-block">
			<div v-if="orderInfo.length > 0">
				<van-cell title="商品名" :value="orderInfo[0].goods_name" />
				<van-cell title="价格" :value="orderInfo[0].goods_price" />
				<van-cell title="数量" :value="orderInfo[0].goods_num" />
				<van-cell title="合计金额" :value="orderInfo[0].goods_pay_price" />
				<van-cell title="图片">
					<template #right-icon>
						<van-image
						  width="100"
						  height="100"
						  :src="orderInfo[0].image_240_url"
						/>
					</template>
				</van-cell>
			</div>
		</div>
	</div>
</template>

<script>
import { getOrderInfo } from '../../../api/sale'
export default {
  name: 'OrderInfo',
	components: {
	},
  data () {
    return {
			// 商品详情
			orderInfo: []
    }
  },
	methods: {
		// 返回上一页
		goBack () {
			this.$router.go(-1)
		}
	},
	created () {
		getOrderInfo(this.$route.params.orderId).then(res => {
			// 商品详情信息
			this.orderInfo = res.result.order_info.goods_list
		}).catch(error=>{
			// 
		})
	}
}
</script>

<style lang="scss" scoped>
.order-info {
	font-size: 14px;
}
.order-info   ::v-deep.van-nav-bar {
	background-color: #e93b3d;
	color: white;
	.van-icon-arrow-left, .van-nav-bar__text, .van-nav-bar__title {
		color: white;
	}
}
</style>
